import React from 'react';
import { Box, Typography } from '@mui/material';
import { ProvenanceTab, ProvenanceSectionId } from '../wizard/ProvenanceTab';

interface StepProps {
  catalogItemId?: string;
  ownerId?: string | null;
}

const SECTIONS: ReadonlySet<ProvenanceSectionId> = new Set<ProvenanceSectionId>([
  'provenance-awards',
]);

const NOTE =
  'Reference awards, prizes, grants, or honors associated with this object. Pick from awards already on your CV, or type a new one.';

/** Awards promoted from ProvenanceTab into its own step. */
export const AwardsStep: React.FC<StepProps> = ({ catalogItemId, ownerId }) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
    <Typography
      variant="body2"
      color="text.secondary"
      data-testid="awards-step-note"
    >
      {NOTE}
    </Typography>
    <ProvenanceTab
      catalogItemId={catalogItemId}
      ownerId={ownerId}
      visibleSections={SECTIONS}
      flatSections
    />
  </Box>
);
